import { ExternalLink } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { TentacleCalloutHeading } from "./TentacleCalloutHeading";
export const LinuxPollingTentacleCallout: React.FC<{}> = () => (<div>
        <h3>Installation Instructions</h3>
        <TentacleCalloutHeading />
        <p>
            For getting started instructions please visit the <ExternalLink href="LinuxListeningTentacle">Linux Tentacle documentation</ExternalLink>.
        </p>
    </div>);
LinuxPollingTentacleCallout.displayName = "LinuxPollingTentacleCallout"
export default LinuxPollingTentacleCallout;
